import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import { AuthService } from './core/auth.service';
import { User } from './core/user';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  hideWidgets = false;
  currentUser: Observable<User>;
  currentUserData: Object;
  currentURL = "/home";

  constructor(private router: Router, private auth: AuthService) {
    this.router.events.subscribe(event => {
      const url = this.router.url;
      // console.log(url);
      console.log("URL",url);
      this.currentURL = url;
      if (url === '/login' ) {
        this.hideWidgets = true;
      } else {
        this.hideWidgets = false;
      }
    });
    this.getCurrentUser();
  }
  getCurrentUser() {
    this.currentUser = this.auth.getCurrentUser();

    this.currentUser.subscribe(
      done => {
        console.log('done value', done);
        this.currentUserData = done;
      },
      error => {
        console.log('Error value', error);
      },
      () => {
        console.log('finished');
      }
    );
  }

  logout() {
    this.auth.signOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts